// Industrial expertise content.
export const EXPERTISE = [
  {
    slug: "polyurethane",
    title: "Polyurethane",
    short:
      "PU systems, raw materials, formulation logic, applications, system-house considerations and technical-commercial development.",
    lead:
      "Polyurethane is one of the most versatile material platforms in industry, spanning rigid and flexible foams, elastomers, coatings, adhesives and sealants. MATRIVON's perspective is grounded in direct experience with PU manufacturing, R&D and formulation, combined with commercial development of PU systems across multiple markets.",
    points: [
      "Polyol and isocyanate raw-material selection",
      "Formulation logic and reactive balance",
      "Rigid, flexible, PUR and PIR systems",
      "Elastomers, coatings, adhesives and sealants",
      "System-house and processor considerations",
      "Technical-commercial development",
    ],
    technicalLink: "/technical-hub/polyurethane",
  },
  {
    slug: "silicones",
    title: "Silicone Elastomers",
    short:
      "RTV, LSR and HCR silicone elastomers, compounding concepts, applications, market development and distribution.",
    lead:
      "Silicone elastomers combine unusual thermal, electrical and durability properties with demanding compounding and processing requirements. MATRIVON works across HCR, LSR and RTV systems, connecting compounding architecture to application performance and commercial opportunity.",
    points: [
      "HCR, LSR and RTV systems",
      "Silicone gum, fillers and cure systems",
      "Compounding architecture and process aids",
      "Extrusion and moulding compounds",
      "Application and market development",
      "Distribution and channel strategy",
    ],
    technicalLink: "/technical-hub/silicones",
  },
  {
    slug: "polymers-specialty-chemicals",
    title: "Polymers & Specialty Chemicals",
    short:
      "Functional polymers, specialty materials, additives and application-driven industrial markets.",
    lead:
      "Specialty chemicals and functional polymers succeed or fail on application fit. MATRIVON assesses these materials where technology meets a specific industrial need, and where commercial value is genuinely created.",
    points: [
      "Functional and performance polymers",
      "Additives and modifiers",
      "Specialty and performance materials",
      "Application-driven market segments",
      "Value-in-use assessment",
      "Route-to-market for technical products",
    ],
    technicalLink: "/technical-hub",
  },
  {
    slug: "coatings-adhesives-sealants",
    title: "Coatings, Adhesives & Sealants",
    short:
      "Commercial and technical perspectives across industrial formulations, construction-related applications and specialty materials.",
    lead:
      "Coatings, adhesives and sealants sit at the intersection of chemistry, application and specification. MATRIVON brings commercial and technical perspectives to these formulation-driven markets, including construction-related and specialty applications.",
    points: [
      "Industrial coating systems",
      "Structural and specialty adhesives",
      "Construction and specialty sealants",
      "Formulation and specification drivers",
      "Application and substrate considerations",
      "Market and channel development",
    ],
    technicalLink: "/technical-hub",
  },
  {
    slug: "industrial-b2b",
    title: "Industrial B2B Markets",
    short:
      "Complex sales cycles, technical customers, distributors, strategic accounts and multi-country market development.",
    lead:
      "Industrial B2B markets have their own logic: long sales cycles, technically demanding customers, layered distribution and strategic accounts. MATRIVON's experience spans the commercial development of these markets across multiple countries and regions.",
    points: [
      "Complex, technical sales cycles",
      "Strategic account development",
      "Distributor and channel management",
      "Multi-country market development",
      "Specification and approval processes",
      "Commercial organisation and coverage",
    ],
    technicalLink: "/technical-hub",
  },
];

export function getExpertise(slug) {
  return EXPERTISE.find((e) => e.slug === slug);
}
